import * as cx from 'classnames';
import { History } from 'history';
import { index as categoriesIndex } from 'mk/autogenerated/bzCategories';
import {
    BZ2_CAT_FOOTWEAR,
    BZ2_CAT_PRAMS,
    BZ2_CAT_TOYS,
    HOMEPAGE_MORE_CATEGORIES,
    HOMEPAGE_SEARCH_IN_BAZAAR,
    HOMEPAGE_SEARCH_IN_BAZAAR_PLACEHOLDER,
} from 'mk/autogenerated/translations/Bazaar.c146af455938618c064047f296ef02cc'
import { formatThousands } from 'mk/bazaar/common/formatters';
import { bazaar_single_page_product_grid_category_url, bazaar_single_page_product_grid_url } from 'mk/urls/functions';
import Link from 'mk2/components/Link';
import Panel from 'mk2/components/Panel';
import * as React from 'react';
import styles from './Bazaar.mscss';

const pramsCategory = categoriesIndex.find((c) => c.name === 'prams');
const footwearCategory = categoriesIndex.find((c) => c.name === 'footwear');
const toysCategory = categoriesIndex.find((c) => c.name === 'toys');

interface OwnProps {
    className?: string;

    prams: number;
    footwear: number;
    toys: number;
    others: number;
    history?: History;
}

type Props = OwnProps;

interface State {
    value: string;
    focused: boolean;
}

class Bazaar extends React.Component<Props, State> {

    public state: State = {
        value: '',
        focused: false,
    };

    public render() {
        const { className, toys, footwear, prams, others } = this.props;
        const { value, focused } = this.state;

        return (
            <div className={cx(styles.Bazaar, className)}>
                <form
                    className={styles.Bazaar__search}
                    action={bazaar_single_page_product_grid_url()}
                    method="get"
                    onSubmit={undefined/* this.onSubmit *//* TODO: Enable when market will be merged to forum */}
                >
                    <Panel className={cx(styles.Bazaar__search__field, focused && styles['Bazaar__search__field--focused'])} tag="label">
                        <i className={cx('fa fa-search', styles.Bazaar__search__field__icon)} />
                        <input type="hidden" name="sort" value="score_new" />
                        <input
                            value={value}
                            type="text"
                            name="q"
                            placeholder={HOMEPAGE_SEARCH_IN_BAZAAR_PLACEHOLDER}
                            className={styles.Bazaar__search__field__input}
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                        />
                    </Panel>
                    <button
                        className={styles.Bazaar__search__button}
                        type="submit"
                    >
                        {HOMEPAGE_SEARCH_IN_BAZAAR}
                    </button>
                </form>

                <div className={styles.Bazaar__categories}>
                    <Link className={styles.Bazaar__category} to={bazaar_single_page_product_grid_category_url(pramsCategory.slug)}>
                        <div className={cx(styles.Bazaar__category__icon, styles['Bazaar__category__icon--prams'])} />
                        <div className={styles.Bazaar__category__info}>
                            <span className={styles.Bazaar__category__info__title}>
                                {BZ2_CAT_PRAMS}
                            </span>
                            <span className={styles.Bazaar__category__info__hits}>
                                {formatThousands(prams, ' ')}
                            </span>
                        </div>
                    </Link>
                    <Link className={styles.Bazaar__category} to={bazaar_single_page_product_grid_category_url(footwearCategory.slug)}>
                        <div className={cx(styles.Bazaar__category__icon, styles['Bazaar__category__icon--footwear'])} />
                        <div className={styles.Bazaar__category__info}>
                            <span className={styles.Bazaar__category__info__title}>
                                {BZ2_CAT_FOOTWEAR}
                            </span>
                            <span className={styles.Bazaar__category__info__hits}>
                                {formatThousands(footwear, ' ')}
                            </span>
                        </div>
                    </Link>
                    <Link className={styles.Bazaar__category} to={bazaar_single_page_product_grid_category_url(toysCategory.slug)}>
                        <div className={cx(styles.Bazaar__category__icon, styles['Bazaar__category__icon--toys'])} />
                        <div className={styles.Bazaar__category__info}>
                            <span className={styles.Bazaar__category__info__title}>
                                {BZ2_CAT_TOYS}
                            </span>
                            <span className={styles.Bazaar__category__info__hits}>
                                {formatThousands(toys, ' ')}
                            </span>
                        </div>
                    </Link>
                    <Link className={styles.Bazaar__category} to={bazaar_single_page_product_grid_url()}>
                        <div className={cx(styles.Bazaar__category__icon, styles['Bazaar__category__icon--others'])} />
                        <div className={styles.Bazaar__category__info}>
                            <span className={styles.Bazaar__category__info__title}>
                                {HOMEPAGE_MORE_CATEGORIES}
                            </span>
                            <span className={styles.Bazaar__category__info__hits}>
                                {formatThousands(others, ' ')}
                            </span>
                        </div>
                    </Link>
                </div>
            </div>
        );
    }

    private onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const url = bazaar_single_page_product_grid_url({
            q: this.state.value,
            sort: 'score_new',
        });

        if (this.props.history) {
            this.props.history.push(url);
        } else {
            window.location.href = url;
        }
    };

    private onChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            value: event.currentTarget.value,
        });
    };

    private onFocus = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            focused: true,
        });
    };

    private onBlur = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            focused: false,
        });
    };

}

export default Bazaar;
